module.exports = __webpack_public_path__ + "static/media/SireneBackground.ff0a7431.jpg";